/** @jsxImportSource solid-js */
interface Props {
  recommendations: { slug: string; title: string }[]
}

const Recommendations = (props: Props) => {
  const recommendations = props.recommendations

  return (
    <>
      {recommendations && (
        <div class="flex flex-col pb-8">
          <h2 class="text-xl dark:text-[white] mb-2 mt-2">Recommended Posts</h2>
          <div>
            <ul class="list-inside text-base">
              {recommendations.map(({ slug, title }) => (
                <li class="mb-4 mt-4">
                  <a
                    href={`/posts/${slug}`}
                    class="dark:text-indigo-400 text-indigo-700 dark:hover:text-indigo-600 hover:text-indigo-1000 transition duration-150 ease-in-out"
                  >
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default Recommendations
